@if (isOnline) {
    <img #bookmark
         (click)="onClick()"
         (keydown)="onKeyDown($event)"
         [alt]="isActive ?  'Aktives Lesezeichen' : 'Inaktives Lesezeichen'"
         [class.leftBookmark]="isLeft"
         [class.rightBookmark]="!isLeft" [src]="isActive ? ('icon-lesezeichen-active.png' | asset) : ('icon-lesezeichen-inactive.png' | asset)"
         class="bookmark grow"
         tabindex="0"
    />
}